<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4>{{ $t('guides.edit') }}: {{ guideName }}</h4>
          </div>
          <div class="card-body">
            <GuidesForm 
              :guideId="guideId" 
              @form-submitted="formSubmitted" 
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GuidesForm from './GuidesForm.vue';
import router from '@/router';

export default {
  components: {
    GuidesForm
  },
  computed: {
    guideId() {
      return this.$route.query.id;
    },
    guideName() {
      return this.$route.params.name || '';
    }
  },
  methods: {
    formSubmitted() {
      router.push({ name: 'Guides' });
    }
  }
}
</script>

